import React, { useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import employeeApi from "../../services/employeeapi";

const EmployeeViewModal = ({ invModal, employeeId, change }) => {
  const [employeeModal, setEmployeeModal] = useState(invModal);
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleEmployeeClose = () => {
    setEmployeeModal(false);
    change(); // callback to parent
  };

  useEffect(() => {
    setIsLoading(true);
    const fetchDetail = async () => {
      try {
        const res = await employeeApi.getEmployeeDetails({ employeeId });
        if (res?.data) {
          setEmployeeDetails(res.data);
          setIsLoading(false);
        }
      } catch (e) {
        console.error("Failed to fetch employee details:", e);
      }
    };
    fetchDetail();
  }, [employeeId]);

  const formatAddress = (emp) => {
    const parts = [
      emp.address,
      emp.area,
      emp.city,
      emp.state,
      emp.country,
      emp.pincode,
    ];
    return parts.filter(Boolean).join(", ");
  };

  return (
    <div>
      <Modal show={employeeModal} onHide={handleEmployeeClose} size="lg" centered>
        {isLoading ? (
          <div className="p-4">Employee details are loading...</div>
        ) : (
          <>
            <div className="d-flex flex-row justify-content-between align-items-start bg-light w-100 p-4">
              <div className="w-100">
                <h4 className="fw-bold my-2">{employeeDetails.employee.name}</h4>

                <p className="mb-1">
                  <strong>Code:</strong> {employeeDetails.employee.code}
                </p>
                <p className="mb-1">
                  <strong>Designation:</strong>{" "}
                  {employeeDetails.employee.employeeDesignation?.name ?? "N/A"}
                </p>
                <p className="mb-1">
                  <strong>Job Title:</strong> {employeeDetails.employee.jobTitle}
                </p>
                <p className="mb-1">
                  <strong>Qualification:</strong>{" "}
                  {employeeDetails.employee.qualification}
                </p>
                <p className="mb-1">
                  <strong>Department:</strong>{" "}
                  {employeeDetails.employee.employeeDepartment?.name ?? "N/A"}
                </p>
                <p className="mb-1">
                  <strong>Branch:</strong>{" "}
                  {employeeDetails.employee.employeeBranch?.branchName ?? "N/A"}
                </p>
                <p className="mb-1">
                  <strong>Is Branch Admin:</strong>{" "}
                  {employeeDetails.employee.superadmin === 1
                    ? "Yes (Branch Admin)"
                    : "No"}
                </p>
              </div>

              <div className="text-end ms-4">
                <h6 className="fw-bold text-secondary mb-1">
                  {employeeDetails.employee.mobile}
                </h6>
                <h6 className="fw-bold text-secondary mb-1">
                  {employeeDetails.employee.email}
                </h6>
                <h6 className="text-muted mb-0 mt-2">
                  Last Updated:{" "}
                  {moment(employeeDetails.employee.updatedAt).format(
                    "YYYY/MM/DD kk:mm:ss"
                  )}
                </h6>
              </div>
            </div>

            <div className="px-4">
              <p>
                <strong>Address:</strong> {formatAddress(employeeDetails.employee)}
              </p>
            </div>

            <div className="px-4 pt-3">
              <h6 className="fw-bold">Status Change Logs</h6>
              <Table bordered>
                <thead>
                  <tr>
                    <th>Old Status</th>
                    <th>New Status</th>
                    <th className="text-end">Reason</th>
                    <th className="text-end">Updated On</th>
                    <th className="text-end">Updated By (ID)</th>
                  </tr>
                </thead>
                <tbody>
                  {employeeDetails.employeeLog.rows.map((item, i) => (
                    <tr key={i}>
                      <td>{employeeDetails.statusArr[item.old_status]}</td>
                      <td>{employeeDetails.statusArr[item.new_status]}</td>
                      <td className="text-end">{item.reason}</td>
                      <td className="text-end">
                        {moment(item.updated_at).format("YYYY/MM/DD kk:mm:ss")}
                      </td>
                      <td className="text-end">{item.updated_by}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <div className="pb-4 px-4">
              <Row>
                <Col md={6}>
                  <Button
                    variant="danger"
                    className="d-block w-100"
                    onClick={handleEmployeeClose}
                  >
                    Close
                  </Button>
                </Col>
              </Row>
            </div>
          </>
        )}
      </Modal>
      <hr className="mt-4 mb-3" />
    </div>
  );
};

export default EmployeeViewModal;
